"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLoadersProvider = exports.AppLoadersContext = void 0;
var _merge = _interopRequireDefault(require("es-toolkit/compat/merge"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const AppLoadersContext = exports.AppLoadersContext = /*#__PURE__*/(0, _react.createContext)(null);
const AppLoadersProvider = ({
  defaultValues = {},
  children
}) => {
  const [appLoaders, setAppLoaders] = (0, _react.useState)(defaultValues);
  const updateAppLoaders = (0, _react.useCallback)(newState => {
    setAppLoaders(prevState => (0, _merge.default)({}, prevState, newState));
  }, []);
  const value = (0, _react.useMemo)(() => ({
    appLoaders: Object.keys(appLoaders).length > 0 ? appLoaders : undefined,
    setAppLoaders: updateAppLoaders
  }), [appLoaders, updateAppLoaders]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AppLoadersContext.Provider, {
    value: value,
    children: children
  });
};
exports.AppLoadersProvider = AppLoadersProvider;
